export function loadScript(src: string, id: string, async = false) {
  return new Promise((res, rej) => {
    if (document.getElementById(id)) return;

    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = async;
    document.head.append(script);
    script.onload = res;
    script.onerror = rej;
  });
}

export function loadCSS(href: string) {
  const fileref = document.createElement('link');
  fileref.rel = 'stylesheet';
  fileref.type = 'text/css';
  fileref.href = href;
  document.getElementsByTagName('head')[0].appendChild(fileref);
}
